import { render, staticRenderFns } from "./ai-face-swap-funny.vue?vue&type=template&id=72002cec&lang=pug&"
import script from "./ai-face-swap-funny.vue?vue&type=script&lang=js&"
export * from "./ai-face-swap-funny.vue?vue&type=script&lang=js&"
import style0 from "./ai-face-swap-funny.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports